import { createAction } from 'redux-actions';

export const SESSION_SET = 'SESSION_SET';

export default createAction(SESSION_SET);
